import React from "react";

export default class Spinner extends React.Component {
    render() {
        return (<div className="lds-ring" style={{
            width: "100%",
            display: "flex",
            justifyContent: "center"
        }}>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>);
    }
}



// WEBPACK FOOTER //
// ./../../Deploy/PWS/ViewModels/Components/Events/Spinner.js